import React, { Component } from 'react';
import { Table, } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
import allStocks from '../../data/stock_us_filtered_sorted.json';

class EarningCalender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            earningCalenderList: [],
        };
    }

    componentDidMount() {
        ApiService.getEarningCalender()
            .then(result => {
                console.log('Earning Calender', result);
                let filteredData = [];
                let length = 6;
                if (result.length > 0) {
                   //Remove other country ticker
                    let tmpFiltered = [];
                    for (var i=0; i<result.length; i++){
                        for (var j=0; j<allStocks.length; j++){
                            if (result[i].symbol === allStocks[j].symbol && allStocks[j].type === 'stock'){
                                tmpFiltered.push(result[i]);
                                break;
                            }
                        }
                    }
                    result = tmpFiltered;


                    var helper = {};
                    filteredData = result.reduce(function (r, o) {
                        var key = o.date + '-' + o.time;

                        if (!helper[key]) {
                            helper[key] = Object.assign({}, o); // create a copy of o
                            r.push(helper[key]);
                        } else {
                            helper[key].symbol += ' ' + o.symbol;
                        }

                        return r;
                    }, []);

                    length = filteredData.length < length ? filteredData.length : length;
                    filteredData = filteredData.slice(0, length);
                    console.log('Earning Calender filter', result, filteredData);
                }
                this.setState({ earningCalenderList: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    rederSymbolRow(symbol) {
        if (symbol !== undefined) {
            let url = '/chart/' + symbol;
            return (
                <><Link to={url}>{symbol}</Link>{' '}{' '}{' '}</>
            )
        }
    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.symbol !== undefined) {
            let allSymbols = listValue.symbol.split(' ');
            return (
                <tr key={listValue.symbol + listValue.date + Math.random()}>
                    <td>{listValue.date}</td>
                    <td>{listValue.time.toUpperCase()}</td>
                    <td style={{ overflowWrap: 'break-word', textAlign: 'left' }}>{allSymbols.map(this.rederSymbolRow.bind(this))}</td>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.earningCalenderList !== undefined && this.state.earningCalenderList !== undefined && this.state.earningCalenderList.length > 0) {
            tableRow = this.state.earningCalenderList.map(this.renderRow.bind(this));
        } else {
            tableRow = <tr><td></td><td>No Data</td><td></td></tr>
        }
        console.log('earningCalenderList', this.state.earningCalenderList.length);
        return (
            // <div style={{ overflow: 'scroll', height: '475px' }}>
            // <Card border="secondary" style={{ height: '475px' }}>
            // <Card.Header>Earning Release Calender</Card.Header>     
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }} responsive>
                    <thead>
                        <tr>
                            <th style={{width:'8em'}}>Date</th>
                            <th>Time</th>
                            <th><Link to={'/earningRelease'}>Earning Relase Ticker</Link></th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
                // </Card>
            // </div>
        );
    }
}

export default EarningCalender;
